import { Box, Card, Stack, Typography } from '@mui/material';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';

import DriverLicensePage from '../../license/driver-license/DriverLicensePage';
import { useLanguage } from '../../../utils/i18n';

export default function LicenseReminder({ data = [], loading = false }) {
  const { t } = useLanguage();
  return (
    <Card sx={{ p: 2, borderRadius: 3, boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Box
            sx={{
              background: 'linear-gradient(135deg, #485D9A 0%, #2f3e6b 100%)',
              color: 'white',
              borderRadius: 2,
              width: 44,
              height: 44,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 4px 8px rgba(72,93,154,0.3)'
            }}
          >
            <VerifiedUserIcon />
          </Box>
          <Box>
            <Typography variant="h5" fontWeight="bold" sx={{ color: '#1e293b' }}>
              {t('dashboardAsset.licenseDriverReminder', 'License Driver Reminder')}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {t('dashboardAsset.monitorLicense', 'Monitor document and driver license validity')}
            </Typography>
          </Box>
        </Stack>
      </Stack>

      <Box sx={{ '& > .MuiPaper-root': { boxShadow: 'none', border: '1px solid #e2e8f0', borderRadius: 2 } }}>
        <DriverLicensePage />
      </Box>
    </Card>
  );
}
